import { useEffect, useRef } from 'react';

// This hook will run only once even if state or props changes
export const useOnce = (cb: () => void) => {
  const hasRunRef = useRef(false);

  useEffect(() => {
    if (!hasRunRef.current) {
      cb();
      hasRunRef.current = true;
    }
  }, [cb]);
};
